export default __webpack_public_path__ + "static/media/s14.e1463569.jpg";